module.exports = __webpack_public_path__ + "static/img/viva.23cb15f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/phone/viva.jpg
// module id = ePQc
// module chunks = 1